import { useEffect, useState } from "react";
import { getUsers } from "../api/adminApi";
import AddUserDrawer from "../components/AddUserDrawer";
import AssignRoleDrawer from "../components/AssignRoleDrawer";

const UsersPage = () => {

  const [users, setUsers] = useState([]);
  const [showAddUser, setShowAddUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // ================= LOAD USERS =================
  const loadUsers = async () => {
    try {
      const res = await getUsers();
      setUsers(res.data || []);
    } catch (err) {
      console.error("Users load failed", err);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  // ================= OPEN DRAWER =================
  const openAssignRole = (user) => {
    setSelectedUser(user);
  };

  return (
    <div className="space-y-6">

      {/* ================= HEADER ================= */}
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-black">Users</h2>

        <button
          onClick={() => setShowAddUser(true)}
          className="bg-blue-950 text-white px-4 py-2 rounded-lg font-semibold"
            >
            + Add User
        </button>
      </div>

      {/* ================= TABLE ================= */}
      <div className="bg-white rounded-xl border overflow-hidden">

        <table className="w-full text-sm">
          <thead className="bg-slate-50">
            <tr className="text-left text-slate-500">
              <th className="p-3">User</th>
              <th>Code</th>
              <th>Email</th>
              <th>Roles</th>
              <th>Status</th>
              <th className="text-right pr-4">Actions</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u) => (
              <tr key={u.UserID} className="border-t hover:bg-slate-50">

                <td className="p-3 font-semibold">
                  {u.Name}
                </td>

                <td>{u.UserCode}</td>

                <td>{u.Email}</td>

                <td>{u.Roles ? (
                  <span className="bg-indigo-50 text-indigo-700 px-2 py-1 rounded-md text-xs font-semibold">
                  {u.Roles}
                  </span>
                  ) : (
                  <span className="text-slate-400 text-xs">
                  No Role
                  </span>
                  )}
                </td>

                <td>
                  <span className="text-green-600 font-semibold">
                    Active
                  </span>
                </td>

                {/* ACTIONS */}
                <td className="text-right pr-4 space-x-3">

                  <button className="text-blue-950 font-semibold">
                    Edit
                  </button>

                  <button
                    onClick={() => openAssignRole(u)}
                    className="text-indigo-600 font-semibold"
                  >
                    Assign Role
                  </button>

                </td>

              </tr>
            ))}
          </tbody>

        </table>
      </div>

      {/* ================= ROLE DRAWER ================= */}
      {selectedUser && (
        <AssignRoleDrawer
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
        />
      )}

      {/* ================= USER DRAWER ================= */}

      {showAddUser && (
        <AddUserDrawer
        onClose={() => setShowAddUser(false)}
        onSaved={loadUsers}
        />
      )}

    </div>
  );
};

export default UsersPage;